import Vue from 'vue'
import ModalComponent from './modal.vue'

const instance = (vuetify: any) => {
  const instance = new (Vue.extend(ModalComponent))({
    el: document.createElement('div'),
    vuetify
  })
  return instance
}

const ModalComponents = {
  install: (Vue: any, options: any) => {
    if (Vue.prototype.$modal || !options) {
      return
    }
    Vue.prototype.$modal = instance(options.vuetify)
  }
}

export default ModalComponents
